import {CSSProperties, FC} from 'react';


export interface IIconLengthBmwProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconLengthBmw: FC<IIconLengthBmwProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path d="M18.482 11.315c-.258-.086-2.045-.477-2.045-.477s-3.314-1.884-3.712-1.884H9.6c-.667 0-1.224.509-1.869 1.097-.304.277-.64.582-1.01.853l-1.378.183a.493.493 0 0 0-.343.47v1.58c0 .272.22.493.493.493h.948a1.554 1.554 0 0 0 1.545 1.416c.81 0 1.477-.624 1.546-1.416h4.522a1.554 1.554 0 0 0 1.546 1.416c.81 0 1.477-.624 1.546-1.416h.778c.616 0 .917-.267.993-.516.191-.633.054-1.636-.436-1.8ZM7.986 14.299a.805.805 0 0 1 0-1.608.805.805 0 0 1 0 1.608Zm2.985-3.461H8.274c.195-.154.376-.318.542-.47.436-.397.813-.741 1.265-.741h.89v1.211Zm.656-1.212h.78c.372 0 1.88.876 2.445 1.212h-3.225V9.626ZM15.6 14.3a.805.805 0 0 1 0-1.608.805.805 0 0 1 0 1.608ZM19.5 11.8h2v1h-2v-1ZM23 12.3l-1.5 1.298V11l1.5 1.3ZM4.5 12.799h-2v-1h2v1ZM1 12.299l1.5-1.3v2.599L1 12.299Z" />
        </svg>
    );
};
